<template lang="pug">
  .implementation(v-if="data.step=='implementation'")
    .implementation__text(v-if="data.text", v-html="data.text")
    router-link.implementation__btn(v-if="data.btnText", to="/") {{data.btnText}}

</template>

<script>
import EventBus from '@/eventBus';

//import '@/components/implementation/implementation.styl';
import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
import {ImagePreloaderVue} from '@/mixins/ImagePreloaderVue';
import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

// @ is an alias to /src
//import Events from '@/components/events/Events.vue';

export default {
  name: 'Implementation',

  mixins: [AjaxHelpersVue, ImagePreloaderVue],

  props: {
    data: {
      type: Object,
      required: true,
      default: null
    }
  },

  data() {
    return {

    }
  },

  components: {
    SvgIcon
    //Events
  },

  created() {

  },

  methods: {

  }
}
</script>
